module.exports = __webpack_public_path__ + "static/img/46成都广告.ed346b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/46成都广告.jpg
// module id = IY7C
// module chunks = 1